/*
==========================================================
MODULES
==========================================================
*/

import platform from "./en/platform";
import auth from "./en/auth";
import superAdmin from "./en/superAdmin";
import roles from "./en/roles";
import modules from "./en/modules";

/*
==========================================================
ENGLISH
==========================================================
*/

const en = {

  platform,

  auth,

  superAdmin,

  roles,

  modules

};

export default en;